import { render } from "./StudentDesignCompetition.vue?vue&type=template&id=6a8ea49d&scoped=true"
const script = {}

import "./StudentDesignCompetition.vue?vue&type=style&index=0&id=6a8ea49d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8ea49d"]])

export default __exports__